import request from '@/utils/request'
import { saveMachine, updateMachine } from '@/api/iot/aAccessControlApi'

// 物业端 - 设备列表
export function listAccessControl(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.listAccessControl',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const listData = res.data
        resolve({
          data: listData.machineDtos || listData.records || [],
          total: listData.total || 0,
          communitys: listData.communitys || []
        })
      } else {
        reject(new Error(res.msg || '获取设备列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 授权列表
export function listMachineAuth(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.listMachineAuth',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const listData = res.data
        resolve({
          data: listData.machineAuths || [],
          total: listData.total || 0
        })
      } else {
        reject(new Error(res.msg || '获取授权列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 删除授权
export function deleteMachineAuth(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.deleteMachineAuth',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除授权失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 时段查询
export function listAccessControlTime(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.listAccessControlTime',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data || { timeSlots: [] })
      } else {
        reject(new Error(res.msg || '获取时段配置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 保存时段
export function saveAccessControlTime(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.saveAccessControlTime',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存时段配置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 添加授权
export function saveMachineAuth(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.saveMachineAuth',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '添加授权失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 远程开门
export function remoteOpenDoor(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.remoteOpenDoor',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '远程开门失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 删除设备
export function deleteMachine(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.deleteMachine',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除设备失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 物业端 - 同步设备授权
export function syncMachineAuth(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/property.syncMachineAuth',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '同步授权失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export { saveMachine, updateMachine }
